'use client'

import * as React from 'react'
import { Button } from '@repo/studio-design-system-ui-button'

function DownloadArrowIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      <path d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14" />
    </svg>
  )
}

/**
 * Client island that kicks off the real installer download on mount, then keeps
 * a manual "retry" control around in case the browser blocked the automatic
 * navigation. The installer URL is resolved server-side and handed in as a prop,
 * so no installer endpoint leaks into the statically rendered page chrome.
 */
export function InstallTrigger({ href, retryLabel }: { href: string; retryLabel: string }) {
  React.useEffect(() => {
    window.location.href = href
  }, [href])

  return (
    <Button
      asChild
      variant="overlay"
      // oxlint-disable-next-line cf-web/no-component-class-overrides -- download link with custom icon sizing
      className="rounded-[14px] px-7 shadow-[0_12px_30px_rgba(19,19,21,0.2)] [&_svg]:mx-0 [&_svg]:size-[17px]"
    >
      <a href={href}>
        <DownloadArrowIcon className="size-[17px]" />
        {retryLabel}
      </a>
    </Button>
  )
}
